<template>
    <div class="mobil-top">
      <meta name="viewport" content="maximum-scale=1.0,minimum-scale=1.0,user-scalable=no,width=device-width,initial-scale=1.0">
      <!-- <img v-if='!logo' src="../../../assets/images/mobile-logo.png"/> -->
      <img v-if="logo"  :src="logo" class="logo"/>
      <span v-if="proName">{{proName}}</span>
    </div>
</template>

<script>
export default {
  name: "top",
  props:[
    'proName',
    'logo'
  ],
}
</script>

<style scoped>
.logo{
  margin: 10px 0 5px;
  max-width: 50%;
}
.mobil-top{
  width:100vw;
  max-width:100vw;
  height:34.5vw;
  background: #147ad7;
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items:center;
  justify-content: space-evenly;
}
.mobil-top img{
  width:70.06vw;
}
.mobil-top span{
  font-size:6.9vw;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/train/top.vue